/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_AreaInputs */

const en_admin_resources_area = /** @type {(inputs: Admin_Resources_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area`)
};

const de_admin_resources_area = /** @type {(inputs: Admin_Resources_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fläche`)
};

const es_admin_resources_area = /** @type {(inputs: Admin_Resources_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Área`)
};

const fr_admin_resources_area = /** @type {(inputs: Admin_Resources_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Surface`)
};

const nl_admin_resources_area = /** @type {(inputs: Admin_Resources_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oppervlakte`)
};

/** @type {(inputs: Admin_Resources_AreaInputs) => LocalizedString} */
const it_admin_resources_area = en_admin_resources_area;

/** @type {(inputs: Admin_Resources_AreaInputs) => LocalizedString} */
const pt_br2_admin_resources_area = en_admin_resources_area;

/** @type {(inputs: Admin_Resources_AreaInputs) => LocalizedString} */
const pl_admin_resources_area = en_admin_resources_area;

/** @type {(inputs: Admin_Resources_AreaInputs) => LocalizedString} */
const hu_admin_resources_area = en_admin_resources_area;

/** @type {(inputs: Admin_Resources_AreaInputs) => LocalizedString} */
const ro_admin_resources_area = en_admin_resources_area;

/**
* | output |
* | --- |
* | "Area" |
*
* @param {Admin_Resources_AreaInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_area = /** @type {((inputs?: Admin_Resources_AreaInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_AreaInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_area(inputs)
	if (locale === "de") return de_admin_resources_area(inputs)
	if (locale === "es") return es_admin_resources_area(inputs)
	if (locale === "fr") return fr_admin_resources_area(inputs)
	if (locale === "nl") return nl_admin_resources_area(inputs)
	if (locale === "it") return it_admin_resources_area(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_area(inputs)
	if (locale === "pl") return pl_admin_resources_area(inputs)
	if (locale === "hu") return hu_admin_resources_area(inputs)
	return ro_admin_resources_area(inputs)
});
export { admin_resources_area as "admin.resources.area" }